/* eslint-disable no-empty-function */
import { useEffect, useRef } from "react";
import { ModalSelect } from "../../../../../components/ui/ModalSelect/ModalSelect";
import { AuthParams } from "../../../../../components/common/ModalCustom/components/Form/components/AuthParams";
import { PaymentSystem } from "../../../../../components/common/ModalCustom/components/Form/components/PaymentSystem";
import { useTranslation } from "../../../../../hooks";
import { classNames } from "../../../../../utils/helpers/classNames";

export const Details = ({ methods, selectedStep, setSelectedStep }) => {
  const detailsRef = useRef(null);
  const { payment } = methods.watch();

  const {
    formPlaceholders,
    cabinet: { newOrder: { details } }
  } = useTranslation();

  const handleSetFormParam = (name, data) => methods.setValue(name, data);

  useEffect(() => {
    const handleFocusIn = (e) => {
      if (detailsRef.current && detailsRef.current.contains(e.target) && e.target !== detailsRef.current) {
        setSelectedStep("details");
      }
    };

    document.addEventListener("focusin", handleFocusIn);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="new-order__details" ref={detailsRef}>
      <div className={classNames("new-order__step", { "new-order__step--active": selectedStep === "details" })}>
        <div className="new-order__step-number"><span>2</span></div>
        <div className="new-order__title">{details}</div>
      </div>
      <ModalSelect
        testId="order-goal"
        name="asyncGoals"
        rules={{
          required: true
        }}
        placeholder={formPlaceholders?.proxyGoalField?.select}
        isAsync
        isSelectValid
        setOptions={() => {
        }}
      />
      <AuthParams />
      <PaymentSystem data={payment} setData={handleSetFormParam}/>
    </div>
  );
};
